import { cva } from 'class-variance-authority';

export const iconButtonVariants = cva(
  [
    'inline-flex items-center justify-center shrink-0 select-none',
    'size-7 p-1.5 rounded-sm',
    'bg-transparent text-neutral-foreground',
    'transition-colors',
    "[&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0",
    'hover:cursor-pointer hover:bg-neutral-hover hover:text-neutral-foreground-hover',
    'active:bg-neutral-active active:text-neutral-foreground-active',
    'focus-visible:outline-none focus-visible:ring-[1.5px] focus-visible:ring-inset focus-visible:ring-secondary',
    'disabled:pointer-events-none disabled:bg-transparent disabled:text-neutral-muted-foreground',
  ].join(' ')
);
